import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Box, FormControlLabel, InputBase, makeStyles, Radio, RadioGroup,
  Checkbox as MuiCheckbox } from '@material-ui/core';
import { ReactComponent as UncheckedIcon } from '../../../../static/images/uncheckedIcon.svg';
import { ReactComponent as CheckedIcon } from '../../../../static/images/checkedIcon.svg';
import { Checkbox } from '../Attendance/Setting';
import Dialog from '../../../../components/Dialog';
import { DutyContext } from '../..';
import { dutyAssignAPI } from '../../../../apis';
import { i18n } from '../../../../language';
import { authNameE } from '../../../../utils/userFuncs';
import { store } from '../../../../redux';

const useStyles = makeStyles(() => ({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
  },
  radioGroup: {
    '& .MuiTypography-root': {
      color: '#2E4469',
      fontSize: '1rem',
      fontFamily: 'NotoSans-Medium',
    },
    gap: '1rem',
    '& .MuiFormControlLabel-root': {
      alignItems: 'start',
    },
    '&.MuiFormGroup-root': {
      marginLeft: '0.15rem',
    },
  },
  reminder: {
    fontSize: '0.875rem',
    color: '#C0C6CB',
    fontFamily: 'NotoSans-Medium',
  },
  input: ({ disabled }) => ({
    width: '3rem',
    height: '3rem',
    border: '1px solid #E4E7EB',
    borderRadius: '10px',
    '& .MuiInputBase-input': {
      textAlign: 'center',
      color: '#2E4469',
      fontSize: '1rem',
      fontFamily: 'NotoSans-Medium',
      '&:disabled': {
        opacity: '0.5',
      },
    },
    backgroundColor: disabled ? '#E4E7EB' : '#FFF',
  }),
}));

const DutyRadio = (params) => {
  const classes = useStyles();
  return (
    <Radio
      {...params}
      icon={<UncheckedIcon className={classes.icon} />}
      checkedIcon={<CheckedIcon className={classes.icon} />}
    >
      {params.children}
    </Radio>
  );
};

const ShowRoster = ({ disabled, before, after, onChange }) => {
  const classes = useStyles({ disabled });
  return (
    <Box pt="0.65rem" display="flex" flexDirection="column" gridGap="0.5rem">
      <div>{i18n.t('DUTY_ASSIGN_ROSTER_OPTION3')}</div>
      <Box display="flex" alignItems="center" gridGap="0.5rem">
        {i18n.t('DUTY_ASSIGN_ROSTER_OPTION3_1')}
        <InputBase
          value={before}
          onChange={onChange('beforeDays')}
          className={classes.input}
          disabled={disabled}
          // inputProps={{ maxLength: 1, inputMode: 'numeric', pattern: '[0-7]*' }}
        />
        {i18n.t('DUTY_ASSIGN_ROSTER_OPTION3_2')}
        <InputBase
          value={after}
          onChange={onChange('afterDays')}
          className={classes.input}
          disabled={disabled}
          // inputProps={{ maxLength: 1, inputMode: 'numeric', pattern: '[0-7]*' }}
        />
        {i18n.t('DUTY_ASSIGN_ROSTER_OPTION3_3')}
      </Box>
      <div className={classes.reminder}>{i18n.t('DUTY_ASSIGN_ROSTER_OPTION3_STATEMENT')}</div>
    </Box>
  );
};

const DutyRosterDisplay = ({ handleClose, hasDutyChatValue}) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    dispType: null,
    beforeDays: '',
    afterDays: '',
    version: null,
    isRosterName: 0,
    isSmartComm: 0,
    enableSmartCheck: false
  });
  
  const { rosterId, getIsRosterNameDetail } = useContext(DutyContext);
  const roleMap = store.getState()?.roleMap || {};
  


  const getRosterDispType = useCallback(async () => {
    try {
      const { result } = await dutyAssignAPI.getRosterDispType({ dutyTemplateRosterId: rosterId });
      
      setForm({
        dispType: result?.dispType,
        beforeDays: result?.beforeDays === null ? '' : String(result?.beforeDays),
        afterDays: result?.afterDays === null ? '' : String(result?.afterDays),
        version: result?.version,
        isRosterName: result?.isRosterName,
        isSmartComm: hasDutyChatValue?hasDutyChatValue:result?.isSmartCommunication,
         enableSmartCheck: hasDutyChatValue
      });
    } catch (error) {}
  }, [rosterId]);

  useEffect(() => {
    getRosterDispType();
  }, [getRosterDispType]);

  const handleSelect = (e) => {
    setForm((preData) => ({
      ...preData,
      dispType: Number(e.target.value),
      beforeDays: '',
      afterDays: '',
    }));
  };

  const handleChangeShowRoster = (type) => (e) => {
    const newValue = e.target.value.replace(/[^0-9]/g, '');
    setForm((preData) => ({
      ...preData,
      [type]: newValue,
    }));
  };

  const disabledConfirm = useMemo(() => {
    if (form.dispType === 3) {
      return (
        Number(form.beforeDays) + Number(form.afterDays) > 14 ||
        Number(form.beforeDays) + Number(form.afterDays) === 0 ||
        !form.beforeDays ||
        !form.afterDays
      );
    } else {
      return false;
    }
  }, [form]);

  const updateRosterDispType = useCallback(async () => {
    console.log('form == ', form);
    try {
      const params = {
        afterDays: form.afterDays,
        beforeDays: form.beforeDays,
        dispType: form.dispType,
        dutyTemplateRosterId: rosterId,
        version: form.version,
        isRosterName: form.isRosterName,
        isSmartCommunication: form.isSmartComm
      };

      await dutyAssignAPI.updateRosterDispType(params);
      await getIsRosterNameDetail();
      handleClose();
    } catch (error) {}
  }, [form, rosterId, handleClose]);

  const handleShowRosterName = () => {
    setForm((preData) => ({
      ...preData,
      isRosterName: preData.isRosterName === 0 ? 1 : 0,
    }));
  };

  const handleEnableSmartComm = () => {
    setForm((preData) => ({
      ...preData,
      isSmartComm: preData.isSmartComm === 0 ? 1 : 0,
    }));
  };

  const SmartCheckbox = ({ check, handleChange, id, open, disabled }) => {
  return (
    <MuiCheckbox
      checked={check}
      onChange={handleChange}
      id={id}
      disabled={disabled}   // 👈 forward it here
      color="primary"
    />
  );
};

  return (
    <Dialog
      open={form?.dispType && form?.version ? true : false}
      title={i18n.t('DUTY_ASSIGN_ROSTER_TITLE')}
      cancel={i18n.t('BEDSTATUS_CANCEL')}
      confirm={i18n.t('BEDSTATUS_CONFIRM')}
      dialogfootStyle={{ paddingTop: '1.563rem', boxShadow: '0px -1px 0px 0px #E4E7EB', marginTop: '2.5rem' }}
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={updateRosterDispType}
      disabled={disabledConfirm}
    >
      <Box display="flex" alignItems="center" gridGap="0.65rem" mb="1rem">
        <Checkbox check={Boolean(form.isRosterName)} id="first" handleChange={handleShowRosterName} />
        <div style={{ fontSize: '1rem' }}>Show Roster Name</div>
      </Box>

      <RadioGroup className={classes.radioGroup} value={form.dispType} onChange={handleSelect}>
        <FormControlLabel
          value={1}
          control={<DutyRadio />}
          label={
            <Box pt="0.65rem">
              <div>{i18n.t('DUTY_ASSIGN_ROSTER_OPTION1')}</div>
            </Box>
          }
        />
        <FormControlLabel
          value={2}
          control={<DutyRadio />}
          label={
            <Box pt="0.65rem">
              <div>{i18n.t('DUTY_ASSIGN_ROSTER_OPTION2')}</div>
            </Box>
          }
        />
        <FormControlLabel
          value={3}
          control={<DutyRadio />}
          label={
            <ShowRoster
              disabled={form.dispType !== 3}
              before={form.beforeDays}
              after={form.afterDays}
              onChange={handleChangeShowRoster}
            />
          }
        />
      </RadioGroup>


      {roleMap?.[authNameE.dutyAssign_Enable_Smart_Communication] && (
        <Box
          display="flex"
          alignItems="center"
          gridGap="0.65rem"
          mb="1rem"
          sx={{ marginTop: '30px' }}
        >
          <SmartCheckbox
            check={Boolean(form.isSmartComm)}
            id="esc"
            handleChange={handleEnableSmartComm}
            disabled={form.enableSmartCheck}
          />
          <div style={{ fontSize: '1rem'}}>Enable Smart Communication</div>
        </Box>
      )}
    
    </Dialog>
  );
};

export default DutyRosterDisplay;
